import axios from '../http'
import global from '@/constants/Global.constants'

export default {
  getAddressList (params) { // 获取地址列表
    return axios.post(global.MMC_INFO + '/memberAddress/findMemberAddress', params)
  },
  setDefaultAddress (params) { // 设置默认地址
    return axios.post(global.MMC_INFO + '/memberAddress/updateDefaultAddress', params)
  },
  deleteAddress (params) { // 删除地址
    return axios.post(global.MMC_INFO + '/memberAddress/deleteMemberAddress', params)
  },
  getDefaultAddress (params) { // 获取默认地址
    return axios.post(global.MMC_INFO + '/memberAddress/findMemberDefaultAddress', params)
  },
}



// WEBPACK FOOTER //
// ./src/request/mcc/address.js